import React, { useEffect, useState } from "react";
import "../../../UI Design/Portfolio.css";
import {
  mdiDetails,
  mdiEye,
  mdiFileDocument,
  mdiInformation,
  mdiInformationOutline,
  mdiMagnify,
  mdiOpenInNew,
  mdiPageNextOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import { useNavigate } from "react-router-dom";
import { projects } from "../../../constants/projects.constants";

export default function Portfolio() {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const [projectsToShow, setProjectsToShow] = useState([]);

  useEffect(() => {
    const updateProjectsToShow = () => {
      if (window.innerWidth <= 617) {
        setProjectsToShow(showAll ? projects : projects.slice(0, 3));
      } else if (window.innerWidth <= 768) {
        setProjectsToShow(showAll ? projects : projects.slice(0, 4));
      } else {
        setProjectsToShow(showAll ? projects : projects.slice(0, 6));
        // setProjectsToShow(projects);
      }
    };

    updateProjectsToShow();

    window.addEventListener("resize", updateProjectsToShow);

    return () => {
      window.removeEventListener("resize", updateProjectsToShow);
    };
  }, [projects, showAll]);

  const handleNavigate = (project) => {
    navigate("/project_detail", { state: { project } });
  };

  return (
    <div className="portfolio" id="portfolio">
      <h2 className="heading">
        Latest Client <span>Projects</span>
      </h2>
      <div>
        <div className="portfolio-container">
          {projectsToShow.map((project, index) => (
            <div className="portfolio-box" key={index}>
              <img
                src={project.mainImage}
                alt="Project Image"
                onError={(e) => (e.target.style.display = "none")}
              />
              <div className="portfolio-layer">
                <h4>{project.name}</h4>
                <p>{project.description}</p>
                <button
                  onClick={() => handleNavigate(project)}
                  className="icon-zoom"
                >
                  <Icon path={mdiOpenInNew} className="icon-style" />
                </button>
              </div>
            </div>
          ))}
        </div>
        {!showAll && projects.length > projectsToShow.length && (
          <div style={{ textAlign: "center", marginTop: "4rem" }}>
            <button onClick={() => setShowAll(true)} className="btn">
              View All Projects
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
